import script from "./TheFriendCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFriendCircle.vue?vue&type=script&setup=true&lang=js"

import "./TheFriendCircle.vue?vue&type=style&index=0&id=00324e28&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00324e28"]])

export default __exports__